import { dashboardStats } from '@/services/ventures/dashboard.service'

export default {
	namespaced: true,
	state: {
		dashboardStats: {},
		dashboardStatus: 'pending',
	},
	getters: {
		getDashboardStats: s => s.dashboardStats,
		getDashboardStatus: s => s.dashboardStatus,
	},
	mutations: {
		DASHBOARD_STATS(state, value) { state.dashboardStats = value },
		DASHBOARD_STATUS(state, value) { state.dashboardStatus = value },
	},
	actions: {
		async fetchDashboardStats({ commit }) {
			commit('DASHBOARD_STATUS', 'pending')
			try {
				const { data } = await dashboardStats()
				commit('DASHBOARD_STATUS', 'init')
				commit('DASHBOARD_STATS', data.data || data)
				return data
			} catch (error) {
				commit('DASHBOARD_STATUS', 'init')
				throw error
			}
		},
	},
}
